import {
    SET_NAV_BAR
} from '../../actions';

const initialState = {
    value: 0
}

function navBarReducer (state = initialState, action) {
    const newState = {};

    switch (action.type) {
        case SET_NAV_BAR:
            newState.value = action.status;
            return newState;

        default:
            return state;

    }
}

export default navBarReducer;
